import axios from 'axios';
import type { TeamGetResponseBody } from '@/app-package';

const getTeamList = async () => {
  const { data } = await axios.get<TeamGetResponseBody>('/team');

  return data;
};

type TeamList = TeamGetResponseBody;
export { getTeamList, TeamList };
